@if (store.isLoading()) {
    <div class="d-flex justify-content-center align-items-center w-100 h-100">
        <div class="spinner-grow text-primary loading-spinner" role="status">
            <span class="visually-hidden">{{ { feature: 'System Announcements', component: 'Widget', label: 'Loading' } | translate }}...</span>
        </div>
    </div>
} @else {
    <h5>{{ { feature: 'System Announcements', component: 'Widget', label: "What's New?" } | translate }}</h5>
    <ul class="max-h-[150px] overflow-auto">
        @for (item of store.whatsNewItems(); track item.id) {
            <li>
                {{ item.title }}
                @if (item.description) {
                    <a class="ms-1 text-primary text-sm" role="button" (click)="openDetails(item)" href="javascript:void(0)">
                        {{ { feature: 'System Announcements', component: 'Widget', label: 'more' } | translate }}
                    </a>
                }
            </li>
        } @empty {
            <li>{{ { feature: 'System Announcements', component: 'Widget', label: 'No new updates.' } | translate }}</li>
        }
    </ul>

    <h5>{{ { feature: 'System Announcements', component: 'Widget', label: 'Announcements' } | translate }}</h5>
    <ul class="max-h-[150px] overflow-auto">
        @for (item of store.announcementItems(); track item.id) {
            <li>
                {{ item.title }}
                @if (item.description) {
                    <a class="ms-1 text-primary text-sm" role="button" (click)="openDetails(item)" href="javascript:void(0)">
                        {{ { feature: 'System Announcements', component: 'Widget', label: 'more' } | translate }}
                    </a>
                }
            </li>
        } @empty {
            <li>{{ { feature: 'System Announcements', component: 'Widget', label: 'No announcements.' } | translate }}</li>
        }
    </ul>
}
